import { IconChip } from '@app/core';
import React from 'react';
import { CSMRecommendationType } from '@app/api';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { iconByRecommendationType } from './RecommendationClient';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase,
  },
  text: {
    ...theme.fonts.caption,
  },
  icon: {
    height: 'fit-content',
  },
}));

interface Props {
  type: CSMRecommendationType;
  message: string;
}

export const RecommendationHistory = ({ type, message }: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <IconChip
        className={classes.icon}
        color={iconByRecommendationType[type].color}
        icon={iconByRecommendationType[type].icon}
      />
      <div className={classes.text}>{message}</div>
    </div>
  );
};
